import { Component, Input } from '@angular/core';
import { Format, Price, Product, Rate, TId } from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';

@Component({
    selector: 'app-products-prices',
    templateUrl: './products-prices.component.html',
    styleUrls: ['./products-prices.component.sass'],
    standalone: false
})
export class ProductsPricesComponent {

  @Input() productId: TId | undefined;

  productPrices: Price[];
  products: Product[];
  rates: Rate[];
  formats: Format[];

  constructor(private _master: MasterApiService) {
    this.productPrices = [];
    this.products = [];
    this.rates = [];
    this.formats = [];
  }

  ngOnInit(): void {
    if (this.productId !== undefined) {
      this._master.getProductPrices(this.productId).subscribe(data => this.productPrices = data);
    }
  }

}
